var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{directives:[{name:"t",rawName:"v-t",value:('error.404.title'),expression:"'error.404.title'"}]})}
var staticRenderFns = []

export { render, staticRenderFns }